<template>
    <div class="w-full">
        <ul class="flex flex-row">
            <li class="mr-8">
                <vs-radio :color="radioButtonColor" v-model="paymentOptionType" vs-value="1">
                  {{ $t('frontend_groovemail_components_pricepoint_onetime') }}
                </vs-radio>
            </li>
            <li class="mr-8">
                <vs-radio :color="radioButtonColor" v-model="paymentOptionType" vs-value="2">
                  {{ $t('frontend_groovemail_components_pricepoint_recurring') }}
                </vs-radio>
            </li>
            <li class="mr-8">
                <vs-radio :color="radioButtonColor" v-model="paymentOptionType" vs-value="3">
                  {{ $t('frontend_groovemail_components_pricepoint_installments') }}
                </vs-radio>
            </li>
        </ul>
        <div class="mt-4">
            <text-area 
              class="mb-8"
              variant="base"
              v-model="priceDescription"
              :placeholder="$t('frontend_product_step2_price_description')"
            />
            
            <div class="flex flex-row w-full mb-8">
                <text-input 
                  class="w-1/3 mr-8 pricePointsPrice"
                  variant="base"
                  v-model="price"
                  :placeholder="$t('frontend_product_step2_price')"
                />
                
                <text-input 
                  v-if="paymentOptionType === 3"
                  class="w-1/3 mr-8 pricePointsInstallments"
                  variant="base"
                  v-model="noOfInstallments"
                  :placeholder="$t('frontend_gduikit_pricepoint_no_of_installments')"
                />
                <gd-dropdown class="w-1/4 mr-8 recurringIntervalDropdown" v-if="paymentOptionType != 1" v-model="recurringIntervalValue" :value="recurringIntervalValue" :options="recurringOptionsList"></gd-dropdown>
                <label class="w-1/3 mr-8 pt-3" v-if="paymentOptionType === 2">
                {{ $t('frontend_groovemail_components_pricepoint_until_cancelled') }}
                </label>
            </div>
            <div class="">
                <span class="mr-4">
                  {{ $t('frontend_groovemail_components_pricepoint_set_as_default') }}
                </span>
                <gd-toggle
                  bgClass="bg-grey-300"
                  v-model="isDefaultPrice"
                  @change="isDefaultPrice = !isDefaultPrice"
                />
            </div>
        </div>
    </div>
</template>

<script>
import themeConfig from '@/theme/themeConfig.js';

export default {
  name: 'price-point',
  props: ['pricePoint'],
  methods: {
  },
  data() {
    return {
      radioButtonColor: themeConfig.appPrimaryColor,
      recurringOptionsList: [
        { text: this.$t('frontend_weekly'), value: 1 },
        { text: this.$t('frontend_dashboard_checkout_every_weeks'), value: 2 },
        { text: this.$t('frontend_monthly'), value: 3 },
        { text: this.$t('frontend_dashboard_checkout_every_months'), value: 4 },
        { text: this.$t('frontend_quarterly'), value: 5 },
        { text: this.$t('frontend_dashboard_checkout_half_yearly'), value: 6 },
        { text: this.$t('frontend_yearly'), value: 7 },
        { text: this.$t('frontend_dashboard_checkout_every_years'), value: 8 }
      ],
    };
  },
  created() {
  },
  computed: {
    paymentOptionType() {
      return this.pricePoint.paymentOptionType;
    },

    priceDescription() {
      return this.pricePoint.priceDescription;
    },

    price() {
      return this.pricePoint.price;
    },

    recurringIntervalValue() {
      return this.pricePoint.recurringIntervalValue;
    },


    noOfInstallments() {
      return this.pricePoint.noOfInstallments;
    },

    isDefaultPrice() {
      return this.pricePoint.isDefaultPrice;
    },
  },
};
</script>
